import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import IMask from 'imask';

const FormularioContato = () => {
    const components = document.querySelectorAll('[data-component="formulario_trabalhe_conosco"]');

    components.forEach(component => {
        const form = component.querySelector('form');
        new Bouncer('#formContact', {
            disableSubmit: true,
            messageAfterField: false,
            messages: {
                missingValue: {
                    checkbox: '',
                    radio: '',
                    select: '',
                    'select-multiple': '',
                    default: 'Campo de preenchimento obrigatório',
                },
                patternMismatch: {
                    email: 'Por favor, insira um e-mail válido',
                    telefone: 'Por favor, insira um telefone válido',
                    default: 'Formato inválido',
                },
            },
            emitEvents: true,
        });

        form.addEventListener('bouncerFormValid', async (event) => {
            event.preventDefault();

            const formEl = event.target;
            const submitEl = formEl.querySelector('[type="submit"]');
            const success = formEl.querySelector('.success');
            const error = formEl.querySelector('.error');

            submitEl?.setAttribute('disabled', 'disabled');

            const recaptchaInput = formEl.querySelector("input[name='recaptcha_token']");
            const recaptchaFieldName = recaptchaInput?.name || 'recaptcha_token';
            const recaptchaAction = formEl.dataset.recaptchaAction || 'fale_conosco';

            if (window.grecaptcha && window.reloadCaptcha) {
                await new Promise((resolve) => {
                    window.reloadCaptcha(recaptchaAction, recaptchaFieldName, resolve);
                });
            }

            const payload = new FormData(formEl);

            const fileInput = formEl.querySelector('input[name="curriculo"], input[name="curriculo[]"]');
            if (fileInput && fileInput.files && fileInput.files.length > 1) {
                const original = fileInput.name;
                const multiKey = original.endsWith('[]') ? original : `${original}[]`;
                payload.delete(original);
                for (const f of fileInput.files) payload.append(multiKey, f);
            }

            try {
                const url = `${appConfig.baseApiUrl}basedigital/v1/trabalhe-conosco`; // sem barra final
                const response = await axios.post(url, payload, {
                    timeout: 30000,
                });

                submitEl?.removeAttribute('disabled');
                formEl.reset();

                if (response?.status === 200 && response?.data?.ok) {
                    success?.classList.add('active');
                    error?.classList.remove('active');
                } else {
                    error?.classList.add('active');
                    success?.classList.remove('active');
                }

                console.log('[fale-conosco][success]', response.data);
            } catch (e) {
                submitEl?.removeAttribute('disabled');
                error?.classList.add('active');
                success?.classList.remove('active');

                if (e.response) {
                    console.error('[fale-conosco][error][response]', e.response.status, e.response.data);
                } else if (e.request) {
                    console.error('[fale-conosco][error][request]', e.message);
                } else {
                    console.error('[fale-conosco][error]', e.message);
                }
            }
        });

    });
};

export default FormularioContato;

if (document.querySelectorAll('[data-component="formulario_trabalhe_conosco"]').length) {
    FormularioContato();
}
